/**
 * The API's liveness probe (M1-29). Reuses `GET /health` (`Program.cs`, an
 * `AddNpgSql` check against the catalog connection) rather than a dedicated
 * endpoint — verified before reuse: `UseCors` is global middleware ahead of
 * the health-check route, so it carries the same origin policy as every
 * other endpoint, and `TenantResolutionMiddleware` is a no-op for an
 * unauthenticated request (`if (context.User.Identity?.IsAuthenticated ==
 * true)`), so an anonymous poll reaches it cleanly. `/health` is excluded
 * from the OpenAPI spec (`ExcludeFromDescription()`), so this is a raw
 * `fetch`, not `apiClient`.
 *
 * A DB-backed check conflates "DB down" with "API down" — for this app that
 * distinction rarely matters, since nearly every screen needs the database
 * anyway. It is deliberately polled REACTIVELY (only once a real request has
 * already failed — see `lib/maintenance.ts`), not on a standing interval, so
 * a healthy system pays nothing extra for this feature.
 */
const baseUrl = import.meta.env.VITE_API_BASE_URL || window.location.origin;

export async function checkHealth(): Promise<boolean> {
  try {
    const response = await fetch(new URL('/health', baseUrl), {
      cache: 'no-store',
      credentials: 'omit',
    });
    return response.ok;
  } catch {
    return false;
  }
}
